<!--
 * @Author: your name
 * @Date: 2021-05-17 09:29:53
 * @LastEditTime: 2022-01-06 19:03:21
 * @LastEditors: Smart Chow
 * @Description: In User Settings Edit
 * @FilePath: /nqc-ui/src/frameworks/App.vue
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  beforeCreate() {
    // 判断是否是嵌入在iframe中，如果是嵌入iframe中，将菜单移到左侧，隐藏顶部栏。
    const isInsideFrame = self !== top
    this.$store.dispatch('initIsInsideFrame', isInsideFrame)
    // if (this.$route.path == '/') {
    //   //解决清除缓存后页面空白问题
    //   this.$router.push('/')
    // }
  },
  created() {
    this.getTheme()
  },
  methods: {
    getTheme() {
      // url 传过来主题及hospitalCode
      let theme =
        localStorage.getItem('wn-theme') ||
        localStorage.getItem('themeName') ||
        this.$route.query.themeName
      if (theme) {
        switch (theme) {
          case 'default':
            theme = 'winning-winex'
            break
          case 'xyc':
            theme = 'winning'
            break
          case 'dqs':
            theme = 'winning-green'
            break
          default:
            theme = 'winning-winex'
        }
        this.$store.dispatch('setTheme', theme)
      } else {
        // 接收父的值设置主题
        let that = this
        if (!this.$store.state.app.isMulHospital) {
          that.$store.dispatch(
            'setTheme',
            globalConfig.theme ? globalConfig.theme : 'winning-winex'
          )
          return
        }
        if (process.env.NODE_ENV !== 'development') {
          window.addEventListener(
            'message',
            (data) => {
              // 加载主题
              that.$store.dispatch(
                'setTheme',
                data.data.themeName
                  ? data.data.themeName
                  : globalConfig.theme
                  ? globalConfig.theme
                  : 'winning-winex'
              )
            },
            false
          )
        }
      }
    }
  }
}
</script>

<style>
/*  全局的table滚动条 */
.w-table--scrollable-x .w-table__body-wrapper {
  overflow-x: scroll !important;
}

.w-table--scrollable-y .w-table__body-wrapper {
  overflow-y: scroll !important;
}

/* 增加滚动条，悬浮后增加宽度，便于操作 */
::-webkit-scrollbar {
  /*滚动条整体样式*/
  height: 19px !important; /*高宽分别对应横竖滚动条的尺寸*/
  width: 19px !important;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 0;
  border-style: dashed;
  background-color: rgba(57, 62, 72, 0.7);
  border-color: transparent;
  border-width: 6px !important; /*滚动条边框，数值越大 滚动条越宽，占用了滚动条的宽度*/
  background-clip: padding-box;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(57, 62, 72, 0.7);
}

::-webkit-scrollbar-track {
  width: 20px !important;
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(240, 240, 240, 0);
  border-radius: 0;
  /* background: rgba(240, 240, 240, 0.5) ; */
  background: rgba(240, 240, 240, 0);
  cursor: pointer;
}
</style>
